<template>
  <div class="q-header">
    <div class="timer-area" v-if="config.limit && mode !== 'end'">
      <span id="count">{{ limitTime }}</span>
    </div>
    <div class="q-head-btns">
      <div>
        <img
          src="@/assets/img/btn_top.png"
          class="btn-top qh-btn"
          alt="TOP画面"
          @click.prevent="$emit('open', 'modal-top')"
          @touchend.prevent="$emit('open', 'modal-top')"
        />
        <img
          :src="config.audio ? btnOn : btnOff"
          class="btn-off qh-btn"
          :alt="config.audio ? '音をOFFにする' :  '音をONにする' "
          @click.prevent="
            $emit('setConfig', { key: 'audio', value: !config.audio })
          "
          @touchend.prevent="
            $emit('setConfig', { key: 'audio', value: !config.audio })
          "
        />
      </div>
      <div v-if="mode !== 'end'">
        <img
          src="@/assets/img/btn_saiten.png"
          class="btn_saiten qh-btn"
          alt="採点"
          @click.prevent="$emit('open', 'modal-check')"
          @touchend.prevent="$emit('open', 'modal-check')"
        />
      </div>
    </div>
    <div class="title-area">
      <div class="play-title">
        <p id="q-title">
          <span class="play-title-name">{{ drill.title }}</span>
          <span class="q-now" v-if="list">
            <b>{{ now + 1 }}</b>
            /{{ list.length }}
          </span>
          <span class="results-mark" v-else
            ><img src="@/assets/img/icon-check.png" />結果</span
          >
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import btnOn from "@/assets/img/btn_on.png";
import btnOff from "@/assets/img/btn_off.png";

export default {
  props: ["list", "limitTime"],
  computed: {
    mode() {
      return this.$store.state.mode;
    },
    btnOn() {
      return btnOn;
    },
    btnOff() {
      return btnOff;
    },
    drill() {
      return this.$store.getters.drill;
    },
    setting() {
      return this.$store.state.setting;
    },
    config() {
      return this.$store.state.config;
    },
    now() {
      return this.$store.state.questionId;
    }
  }
};
</script>

<style scoped>
.q-header {
  background-color: #39b1e2;
  color: #ffffff;
  position: relative;
  top: 0;
  width: 100%;
  height: 140px;

  display: flex;
  flex-direction: column;
  justify-content: space-between;

  flex: 0 0 140px;
}

.q-head-btns {
  width: 96%;
  margin: 0 auto;
  position: relative;
  display: flex;
  justify-content: space-between;
}

.qh-btn {
  width: 65px;
  margin-top: 3px;
  margin-right: 10px;
  cursor: pointer;
}

.qh-btn:active {
  top: 3px;
}

.btn-top {
  /*
  position: absolute;

  margin-left: -10px;
    */
}

.btn-off {
  /*
  position: absolute;
  left: 65px;
  margin-top: 5px;
    */
}

.btn_saiten {
  /*
  position: absolute;
  right: -5px;
  margin-top: 5px;
      */
  margin-right: 0;
}

.timer-area {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  text-align: center;
}

@media (min-width: 640px) {
  .square {
    /* margin: 0 50% !important; */
  }
}
.square {
  /*
  width: 3em;
  height: 55px;
  */
  display: inline-block;

  border-radius: 20%;
  background-color: #ffffff;
  color: #000000;
  position: relative;
  /*
  top: -22px;
  font-size: 1.5rem;
  margin: 0 45%;
  font-size: 1.2em;
  */
}

#count {
  /*
  position: absolute;
  top: 7px;
  width: 100%;
  */
  margin-top: 10px;

  display: inline-block;
  width: 3em;
  height: 55px;

  line-height: 2.25em;

  border-radius: 20%;
  background-color: #ffffff;
  color: #000000;
  position: relative;
  text-align: center;
  font-family: "Rounded mplus";
  font-size: 1.2em;
}

#q-title {
  display: flex;
  margin: 0;

  justify-content: space-between;
}

.title-area {
  display: flex;
}

.play-title {
  background-color: #ffffff;
  color: #000000;
  padding: 0.25rem 1rem;
  margin: 0 auto;
  width: 96%;
  font-size: 1.15em;
  border-radius: 10px;
  margin-bottom: 15px;
  /*--
  margin-top: -15px;
  position: relative;
  top: 90px;
  --*/
}

.play-title-name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.q-now {
  flex: 0 0 6rem;
  text-align: right;
}
</style>